// Readable writeup URLs, resolved entirely on the client — no backend change,
// no data migration, and old /writeup/<uuid> links keep working.
//
// The slug is derived deterministically from the title, so the same writeup
// always maps to the same URL (e.g. "PG - Kevin" -> /writeup/pg-kevin). The
// page resolves a slug back to a writeup by matching slugify(title) against the
// list it already loads.

export const slugify = (s = "") =>
  String(s)
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[̀-ͯ]/g, "")   // strip accents
    .replace(/[^a-z0-9]+/g, "-")        // non-alphanumerics -> hyphen
    .replace(/^-+|-+$/g, "")            // trim hyphens
    .slice(0, 80) || "writeup";

export const isUuid = (s = "") =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(String(s));

// The canonical path for a writeup. Falls back to the id only if there is no
// title to slug from.
export const writeupPath = (w) =>
  `/writeup/${w?.title ? slugify(w.title) : (w?.id || "")}`;
